import { FilterCategory } from '@bestseller-bit/frontend-community.bootstrapping.application-shell';
import { useMemo } from 'react';
import { PartnerSelection } from 'src/components/organisms/PartnerSelection/PartnerSelection';
import { StoreFilters } from 'src/components/organisms/StoreFilters/StoreFilters';
import { StoreSelectionFilter } from 'src/components/organisms/StoreSelectionFilter/StoreSelectionFilter';
import { useDrawerState } from './useDrawerState';
import { useHasPartnerSelection } from './useHasPartnerSelection';

export const useFilterCategories = () => {
    const { hasSidebar } = useDrawerState();
    const showPartnerSelection = useHasPartnerSelection();
    const isFrontPage = location.pathname === '/';

    const filterCategories: FilterCategory[] = useMemo(() => {
        const categories: FilterCategory[] = [];

        if (showPartnerSelection) {
            categories.push({
                name: 'Partner',
                component: PartnerSelection,
                isAlwaysExpanded: true,
            });
        }
        if (hasSidebar) {
            categories.push({
                name: 'Stores',
                component: StoreSelectionFilter,
                isAlwaysExpanded: true,
            });
        }

        if (isFrontPage) {
            categories.push({
                name: 'Filters',
                component: StoreFilters,
                isAlwaysExpanded: true,
            });
        }

        return categories;
    }, [showPartnerSelection, hasSidebar, isFrontPage]);

    return filterCategories;
};
